// Low-level helpers that keep exactly one managed <meta>/<link> tag per key.
// They reuse existing tags from index.html and only create a tag when missing.

function ensureMeta(attr: 'name' | 'property', key: string): HTMLMetaElement {
  let el = document.head.querySelector<HTMLMetaElement>(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement('meta');
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  return el;
}

function ensureLink(rel: string): HTMLLinkElement {
  let el = document.head.querySelector<HTMLLinkElement>(`link[rel="${rel}"]`);
  if (!el) {
    el = document.createElement('link');
    el.setAttribute('rel', rel);
    document.head.appendChild(el);
  }
  return el;
}

export function setTitle(title: string): void {
  document.title = title;
}

export function setMetaName(name: string, content: string): void {
  ensureMeta('name', name).setAttribute('content', content);
}

export function setMetaProperty(property: string, content: string): void {
  ensureMeta('property', property).setAttribute('content', content);
}

export function setCanonical(href: string): void {
  ensureLink('canonical').setAttribute('href', href);
}